<template>
  <BaseModal
    :size="modalSize"
    :use-portal="true"
    :title="modalTitle"
    v-on="$listeners"
  >
    <template v-slot:openBtn="{ openModal }">
      <div :class="criteriaTitle ? $style.calculatorIconVisibility : ``">
        <img
          :class="$style.calculatorIcon"
          src="@/assets/icons/ic_calculator.png"
          @click="
            () => {
              openModal();
            }
          "
        />
      </div>
    </template>
    <template v-if="siteName || criteriaTitle" v-slot:modalSubtitle>
      <p v-if="siteName" :class="$style.subtitle">{{ siteName }}</p>
      <p v-else :class="$style.subtitle">{{ criteriaTitle }}</p>
    </template>
    <template v-slot:modalBody>
      <div>
        <div class="columns padding-top questionContainer">
          <div class="column labelBox">
            <label :class="$style.label" class="label"
              >What confidence level do you need?</label
            >
          </div>
          <div class="column is-3 inputBox">
            <bField :class="$style.inputContainer">
              <b-input
                v-model="calculateData.confidenceLevel"
                type="number"
                onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                @input="calculateSampleSize"
                placeholder="Enter Number"
              ></b-input>
              <span :class="['control', $style.percentageContainer]">%</span>
            </bField>
          </div>
        </div>
        <div class="columns padding-top questionContainer">
          <div class="column labelBoxRest">
            <label :class="$style.label" class="label"
              >What power do you need?</label
            >
          </div>
          <div class="column is-3 inputBoxRest">
            <bField :class="$style.inputContainer">
              <b-input
                v-model="calculateData.power"
                type="number"
                onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                @input="calculateSampleSize"
                placeholder="Enter Number"
              ></b-input>
              <span :class="['control', $style.percentageContainer]">%</span>
            </bField>
          </div>
        </div>
        <div class="columns padding-top questionContainer">
          <div class="column labelBoxRest">
            <label :class="$style.label" class="label"
              >What do you believe the likely sample proportion in group 1 to
              be?</label
            >
          </div>
          <div class="column is-3 inputBoxRest">
            <bField :class="$style.inputContainer">
              <b-input
                v-model="calculateData.groupOne"
                type="number"
                onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                @input="calculateSampleSize"
                placeholder="Enter Number"
              ></b-input>
              <span :class="['control', $style.percentageContainer]">%</span>
            </bField>
          </div>
        </div>
        <div class="columns padding-top questionContainer">
          <div class="column labelBoxRest">
            <label :class="$style.label" class="label"
              >What do you believe the likely sample proportion in group 2 to
              be?</label
            >
          </div>
          <div class="column is-3 inputBoxRest">
            <bField :class="$style.inputContainer">
              <b-input
                v-model="calculateData.groupTwo"
                type="number"
                onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                @input="calculateSampleSize"
                placeholder="Enter Number"
              ></b-input>
              <span :class="['control', $style.percentageContainer]">%</span>
            </bField>
          </div>
        </div>
      </div>
      <div>
        <div class="columns padding-top totalBoxContainerCalculator">
          <div class="column">
            <label :class="[$style.targetSampleSizeLable, 'label']"
              >Target Sample Size</label
            >
            <label :class="$style.outputSubheading"
              >Recommended target sample size is
              <span :class="$style.outputSubHeadingDisaplay">{{
                calculateData.recommended
              }}</span></label
            >
          </div>
          <div class="column is-3">
            <bField :class="$style.inputTotalContainer">
              <b-input
                v-model="calculateData.output"
                type="number"
                onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                @change.native="updateChildSamplingSize"
                placeholder="Enter Number"
              ></b-input>
            </bField>
          </div>
        </div>
        <template v-if="siteArray">
          <div
            class="columns padding-top totalBoxContainerCalculator"
            :class="$style.childSite"
            v-for="(siteValue, siteIndex) in siteArray"
          >
            <div class="column">
              <label :class="$style.label" class="label">{{
                siteValue.name
              }}</label>
            </div>
            <div class="column is-3">
              <bField :class="$style.inputTotalContainer">
                <b-input
                  :disabled="isDisableInput"
                  v-model="calculateData.sites[siteIndex].calculateData.output"
                  type="number"
                  onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                  @change.native="updateOtherChildSamplingSize(siteIndex)"
                  placeholder="Enter Number"
                ></b-input>
              </bField>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-slot:modalFoot="{ closeModal }">
      <button
        @click="handleApplySampleSize(closeModal)"
        class="button is-primary is-rounded"
        :class="$style.applyButton"
      >
        Apply
      </button>
    </template>
  </BaseModal>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseModal from '@/jbi-shared/vue-components/BaseModal.vue';
import { cloneDeep as _cloneDeep } from 'lodash';
import {
  AuditSamplingSite,
  CalculateData,
} from '@/store/modules/audits/types/audits.types';

@Component({
  components: {
    BaseModal,
  },
})
export default class SamplingCalculator extends Vue {
  @Prop()
  public initialData!: any;
  @Prop()
  public siteArray!: AuditSamplingSite[];
  @Prop()
  public siteName!: string;
  @Prop()
  public criteriaTitle!: string;
  @Prop()
  public auditSiteId!: number;
  @Prop()
  public auditCriteriaId!: number;

  public modalTitle: string = 'Sample Size Calculator';
  public modalSize: string = 'large';
  public calculateData: CalculateData = {
    confidenceLevel: 95,
    power: 80,
    groupOne: 60,
    groupTwo: 40,
    recommended: 0,
    output: 0,
  };
  public isCriteriaBasedMultiSiteSampling = false;
  public isDisableInput: boolean = true;

  public mounted() {
    if (this.initialData) {
      this.calculateData = _cloneDeep(this.initialData);
    }

    if (this.siteArray) {
      this.isCriteriaBasedMultiSiteSampling = true;
      if (this.calculateData.output === 0) {
        this.calculateSampleSize();
      }
    } else {
      this.calculateSampleSize();
    }
  }

  public calculateSampleSize() {
    this.calculateData.output = this.sampleSizeCompareProp(
      Number(this.calculateData.confidenceLevel),
      Number(this.calculateData.power),
      Number(this.calculateData.groupOne),
      Number(this.calculateData.groupTwo),
    );

    this.calculateData.recommended = this.calculateData.output;
    if (
      this.siteArray !== undefined &&
      this.calculateData.sites !== undefined
    ) {
      this.updateChildSamplingSize();
    }
  }

  public sampleSizeCompareProp(
    confidence: number,
    power: number,
    response1: number,
    response2: number,
  ) {
    const pcn = this.probCriticalNormal(confidence / 100.0);
    const pwr = this.probCriticalNormalPower(power / 100.0);

    const d1 = pcn + pwr;
    const d2 =
      d1 *
      d1 *
      (response1 * (100.0 - response1) + response2 * (100.0 - response2));
    const d3 = (response1 - response2) * (response1 - response2);
    if (d3 > 0.0) {
      return Math.ceil(d2 / d3);
    }
    return 0;
  }

  public probCriticalNormal(p: number) {
    // input p is confidence level convert it to
    // cumulative probability before computing critical

    let y: number;
    let pr: number;
    let real1: number;
    let real2: number;
    let hold: number;
    let i: number;
    const pn: number[] = [
      0, // ARRAY[1..5] OF REAL
      -0.322232431088,
      -1.0,
      -0.342242088547,
      -0.0204231210245,
      -0.453642210148e-4,
    ];

    const qn: number[] = [
      0, //  ARRAY[1..5] OF REAL
      0.099348462606,
      0.588581570495,
      0.531103462366,
      0.10353775285,
      0.38560700634e-2,
    ];

    pr = 0.5 - p / 2; // one side significance

    if (pr <= 1.0e-8) {
      hold = 6;
    } else {
      if (pr === 0.5) {
        hold = 0;
      } else {
        y = Math.sqrt(Math.log(1.0 / (pr * pr)));
        real1 = pn[5];
        real2 = qn[5];

        for (i = 4; i >= 1; i--) {
          real1 = real1 * y + pn[i];
          real2 = real2 * y + qn[i];
        }

        hold = y + real1 / real2;
      } // end of else pr = 0.5
    } // end of else Pr <= 1.0E-8

    return hold;
  }

  public probCriticalNormalPower(p: number) {
    // input p is power convert it to
    // cumulative probability before computing critical
    let y: number;
    let pr: number;
    let real1: number;
    let real2: number;
    let hold: number;

    let i: number;
    const pn: number[] = [
      0, // ARRAY[1..5] OF REAL
      -0.322232431088,
      -1.0,
      -0.342242088547,
      -0.0204231210245,
      -0.453642210148e-4,
    ];

    const qn: number[] = [
      0, //  ARRAY[1..5] OF REAL
      0.099348462606,
      0.588581570495,
      0.531103462366,
      0.10353775285,
      0.38560700634e-2,
    ];

    pr = 1 - p;

    if (pr <= 1.0e-8) {
      hold = 6;
    } else {
      if (pr === 0.5) {
        hold = 0;
      } else {
        y = Math.sqrt(Math.log(1.0 / (pr * pr)));
        real1 = pn[5];
        real2 = qn[5];

        for (i = 4; i >= 1; i--) {
          real1 = real1 * y + pn[i];
          real2 = real2 * y + qn[i];
        }

        hold = y + real1 / real2;
      } // end of else pr = 0.5
    } // end of else pr <= 1.0E-8

    return hold;
  }

  public handleCloseButton(closeModal: any) {
    closeModal();
  }

  public handleApplySampleSize(closeModal: any) {
    let emitData: any = this.calculateData;
    if (this.auditSiteId !== undefined) {
      emitData = {
        ...emitData,
        auditSiteId: this.auditSiteId,
      };
    }

    if (this.auditCriteriaId !== undefined) {
      emitData = {
        ...emitData,
        auditCriteriaId: this.auditCriteriaId,
      };
    }
    this.$emit('applySampleSize', emitData);
    closeModal();
  }

  public updateChildSamplingSize() {
    if (
      this.siteArray !== undefined &&
      this.calculateData.sites !== undefined
    ) {
      const parentVal = this.calculateData.output;
      const siteArrayLength = this.siteArray.length;
      const modulo = parentVal % siteArrayLength;
      const childVal = (parentVal - modulo) / siteArrayLength;
      this.calculateData.sites.forEach(
        (currentVal: AuditSamplingSite, siteIndex: number) => {
          currentVal.calculateData.output =
            siteIndex === 0 ? childVal + modulo : childVal;
        },
      );
    }
  }

  public updateOtherChildSamplingSize(siteIndex: number) {
    if (
      this.siteArray !== undefined &&
      this.calculateData.sites !== undefined
    ) {
      const currentElementVal = !this.calculateData.sites[siteIndex]
        .calculateData.output
        ? 0
        : Number(this.calculateData.sites[siteIndex].calculateData.output);
      const parentVal: number = !this.calculateData.output
        ? 0
        : Number(this.calculateData.output);
      if (parentVal < currentElementVal) {
        this.updateChildSamplingSize();
      } else {
        const tempParentVal = parentVal - currentElementVal;
        const siteArrayLength = Number(this.siteArray.length - 1);
        const modulo = tempParentVal % siteArrayLength;
        const childVal = (tempParentVal - modulo) / siteArrayLength;
        this.calculateData.sites.forEach(
          (currentVal: AuditSamplingSite, currentSiteIndex: number) => {
            if (currentSiteIndex !== siteIndex && siteIndex !== 0) {
              currentVal.calculateData.output =
                currentSiteIndex === 0 ? childVal + modulo : childVal;
            } else if (currentSiteIndex !== siteIndex) {
              currentVal.calculateData.output =
                currentSiteIndex === 1 ? childVal + modulo : childVal;
            }
          },
        );
      }
    }
  }

  @Watch('calculateData', { deep: true })
  public onCheckCalculateData(value: any) {
    if (value.sites) {
      this.isDisableInput = Number(value.output) !== 0 ? false : true;
    }
  }
}
</script>
<style lang="scss" module>
.bField .label {
  color: #9f9f9f;
  font-size: 14px;
}

.calculatorIcon {
  width: 16px;
  height: 20px;
  cursor: pointer;
  margin-left: 8px;
}
.inputContainer {
  position: relative;
  float: right;
  input {
    width: 80px;
    height: 44px;
    text-indent: 15px;
    background-color: white !important;
    border-color: #dfdfdf !important;
    color: #444f51 !important;
    padding: 7px 7px;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  }
  .percentageContainer {
    position: absolute;
    right: 6px;
    font-size: 18px;
    top: 13px;
    z-index: 4;
  }
}
.inputTotalContainer {
  position: relative;
  float: right;
  input {
    width: 80px;
    height: 44px;
    background-color: white !important;
    border-color: #dfdfdf !important;
    color: #444f51 !important;
    padding: 7px 7px;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
    text-align: right;
  }
}
.borderBottom {
  border-bottom: 0.5px solid #dbdbdb;
}
.targetSampleSizeLable {
  color: #444f51;
  font-size: 16px;
  font-weight: bold;
}
.outputSubheading {
  font-size: 14px;
}
.outputSubHeadingDisaplay {
  font-weight: bold;
}
.childSite {
  padding-left: 16px;
}
.label {
  font-size: 16px;
  color: #444f51;
}
.subtitle {
  color: #444f51;
  font-size: 16px;
  font-weight: initial;
  padding-top: 8px;
}
.calculatorIconVisibility > img {
  visibility: hidden;
}
.applyButton {
  width: 100px !important;
  height: 48px !important;
}
</style>
